/**
 * Seslendirme (v0.1.255, migration 0139): a text voiced through Genesis /v1/audio/speech, one mp3 per part.
 *   GET  /voice                    the newest jobs with their parts, and the voices Genesis lists.
 *   POST /voice/jobs               a new job (panel, signed in): a title, the parts and optionally voice, model, speed.
 *   GET  /media/voice/{assetId}    the mp3 of a done part.
 */
import { z } from 'zod';
export const VOICE_MODELS = ['bmu-voice', 'bmu-voice-fast', 'bmu-voice-v3'];
export const VOICE_DEFAULT_ID = 'JBFqnCBsd6RMkjVDRZzb';
export const VOICE_PART_MAX = 5000;
export const VOICE_JOB_MAX_PARTS = 40;
export const VOICE_JOB_MAX_CHARS = 60_000;
export const voicePartInputSchema = z.object({
    id: z.string().regex(/^[A-Za-z0-9][A-Za-z0-9_-]{0,39}$/),
    text: z.string().trim().min(1).max(VOICE_PART_MAX),
});
export const voiceJobBodySchema = z
    .object({
    title: z.string().trim().min(1).max(200),
    parts: z.array(voicePartInputSchema).min(1).max(VOICE_JOB_MAX_PARTS),
    voiceId: z
        .string()
        .regex(/^[A-Za-z0-9]{8,40}$/)
        .optional(),
    model: z.enum(VOICE_MODELS).optional(),
    speed: z.number().min(0.7).max(1.2).optional(),
})
    .refine((body) => new Set(body.parts.map((part) => part.id)).size === body.parts.length, {
    message: 'part ids must be unique',
})
    .refine((body) => body.parts.reduce((sum, part) => sum + part.text.length, 0) <= VOICE_JOB_MAX_CHARS, {
    message: 'at most 60000 characters',
});
export const voicePartSchema = z.object({
    ord: z.number().int(),
    id: z.string(),
    chars: z.number().int(),
    status: z.enum(['queued', 'done', 'failed']),
    /** The mp3 (GET /media/voice/{assetId}) once done. */
    assetId: z.string().nullable(),
    bytes: z.number().int().nullable(),
    costMicroUsd: z.number().int().nullable(),
    error: z.string().nullable(),
});
export const voiceJobSchema = z.object({
    jobId: z.string(),
    title: z.string(),
    voiceId: z.string(),
    voiceName: z.string().nullable(),
    model: z.string(),
    speed: z.number(),
    status: z.enum(['queued', 'running', 'done', 'failed']),
    error: z.string().nullable(),
    costMicroUsd: z.number().int(),
    createdBy: z.string(),
    createdAt: z.number().int(),
    finishedAt: z.number().int().nullable(),
    parts: z.array(voicePartSchema),
});
export const voiceCatalogEntrySchema = z.object({
    voiceId: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    labels: z.record(z.string(), z.string()),
    previewUrl: z.string().nullable(),
});
export const voiceViewSchema = z.object({
    jobs: z.array(voiceJobSchema),
    voices: z.array(voiceCatalogEntrySchema),
    defaults: z.object({ voiceId: z.string(), model: z.enum(VOICE_MODELS), speed: z.number() }),
});
export const voiceJobCreatedSchema = z.object({ jobId: z.string(), parts: z.number().int() });
//# sourceMappingURL=voice.js.map